import { css } from 'linaria';

export const ListClassName = css`
  display: flex;
  flex-direction: column;
  gap: var(--space-100);
`;

export const ListItemClassName = css`
  border-radius: var(--rounding-m);
  border: 1px solid var(--control-secondary);
  display: flex;
  padding: 12px;
  gap: 12px;
  cursor: pointer;
`;

export const ListItemSelectedClassName = css`
  border: 1px solid var(--control-accent);
  cursor: initial;
`;

export const ListItemCircleClassName = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 24px;
  background: var(--control-minor);
`;

export const ListItemTextClassName = css`
  color: var(--text-primary);
  font-size: 15px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0.2px;
`;
